import { render, staticRenderFns } from "./HubPages.vue?vue&type=template&id=22920fb3&scoped=true&"
import script from "./HubPages.vue?vue&type=script&lang=js&"
export * from "./HubPages.vue?vue&type=script&lang=js&"
import style0 from "./HubPages.vue?vue&type=style&index=0&id=22920fb3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22920fb3",
  null
  
)

export default component.exports